module.exports = __webpack_public_path__ + "static/printing-services-banner-53f8cc9aa54e787b4b61bc63e245eb4f.jpg";